import React from 'react'
import { Link as GatsbyLink } from 'gatsby'

const domainRegex = /www.*paypalobjects\.com\/ppdevdocs\/v2noapi\/?/
const MarkdownLink = ({ href = '#', ...rest }) => {
  const sameDomain = domainRegex.test(href)
  if (sameDomain) {
    href = href.replace(domainRegex, '')
  }

  if (href.startsWith('/') && (!rest.target || rest.target !== '_blank')) {
    return <GatsbyLink data-link-internal to={href} {...rest} />
  }

  // Treat urls that aren't web protocols as "normal" links
  if (!href.startsWith('http')) {
    return <a href={href} {...rest} />
  }

  return <a href={href} {...rest} />
}

export default MarkdownLink
